<p-dialog
  class="dialog-affirmation"
  *ngIf="showDialog && authority"
  class="change-request-dialog"
  blockScroll="true"
  [modal]="true"
  [closeOnEscape]="false"
  header="Modify: Authority #{{ authority?.ec1Number }}"
  [(visible)]="showDialog && authority"
  (onHide)="closeModify()"
  [ngClass]="{ 'padding-bottom-cr': authority.isAuthorityShared }"
>
<div>
  <div class="request-authority-blocking" [hidden]="!blockDialog">
    <span>Loading...</span>
  </div>

  <div class="change-request-content-wrapper inputStyle">
    <div class="request-authority-content-row ">
      <div class="request-authority-content-column ">
        MP:
        <strong>{{ authority?.entryLocation.prefix }} {{ authority?.entryLocation.milepost }}</strong>
      </div>
      <div class="request-authority-content-column effective-date ">
        Effective: {{ authority?.effective | estDate | date: 'MM/dd/yyyy HH:mm' }}
      </div>
      <div class="request-authority-content-column input-range-label">Range: {{ authority?.entryLocation.range }}</div>
    </div>

    <div class="request-authority-content-row ">
      <div class="request-authority-content-column until-time input-until-dt" style="width:auto;">
        <label>Until Date &amp; Time:</label>
        <span *ngIf="isReportByTouched()"> {{ authority?.expiration | estDate | date: 'MM/dd/yyyy HH:mm' }} </span>
        <div *ngIf="!isReportByTouched()">
          <p-calendar
            [style]="{ 'padding-right': '10px' }"
            [(ngModel)]="oldExpiration"
            dateFormat="mm/dd/yy"
            name="calendarInput"
            [keepInvalid]="true"
            [showOnFocus]="false"
            [showIcon]="true"
            readonlyInput="readonlyInput"
            [minDate]="minDate"
            [inputStyleClass]="invalidUntilTime() && isUntilTimeChanged() ? 'invalid' : ''"
          ></p-calendar>
          <input
            class="input-time input-time-left"
            oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
            type="number"
            min="1"
            max="23"
            [(ngModel)]="expirationHour"
            maxlength="2"
            [ngClass]="{ invalid: invalidUntilTime() && isUntilTimeChanged() }"
          />
          <span class="input-time-separator">:</span>
          <input
            class="input-time input-time-right"
            oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
            type="number"
            min="1"
            max="59"
            [(ngModel)]="expirationMins"
            maxlength="2"
            [ngClass]="{ invalid: invalidUntilTime() && isUntilTimeChanged() }"
          />
        </div>
      </div>
      <div *ngIf="invalidUntilTime() && isUntilTimeChanged()" class="request-authority-content-column until-time error-message">
        <span class="invalid-time">{{ errorMessageInvalidTime }} </span>
      </div>
      <div *ngIf="isReportByTouched()" class="request-authority-content-column until-time" style="width:100%;padding-top: 3px">
        <span class="csx-common_lock"> </span>Cannot modify Until time while performing Report By
      </div>
    </div>

    <div
      class="request-authority-content-row "
      *ngFor="let item of lineItemsModify; let i = index"
      [ngClass]="{ 'hide-items': item.cancelled !== undefined, disabled: item.isUserCancelled }"
    >
      <div class="lineItemHeader">
        <div class="request-authority-content-column line-item-count">
          <p>Line {{ item.lineNumber }}</p>
        </div>
        <div class="request-authority-content-column line-item-delete">
          <span>
            <button
              class="buttton-close"
              style="cursor:pointer;outline:none;"
              [ngClass]="{ 'blur-reportBy-selected': isReportByTouched() || item.isUserCancelled || getActiveCount() <= 1 }"
              (click)="clickCancel(item)"
            >
              Cancel Line
            </button>
          </span>
        </div>
      </div>
      <change-request-line-item
        [directionLock]="UserClickedReportBy"
        [authorityPointGroupListChild]="authorityPointGroupList"
        [resetDirection]="resetDirection"
        [line11Lock]="line11TrainLock"
        [lineItem]="item"
        (undo)="undoAction($event)"
      ></change-request-line-item>
    </div>

    <div style="padding-bottom: 10px;  border-top: 1px solid #C0C2C7;padding-top: 5px;" *ngIf="authority.crossOvers.length > 0">
      <div
        class="crossoverCntr"
        [ngClass]="{ 'hide-items': crossOver.cancelledDate !== undefined }"
        *ngFor="let crossOver of authority.crossOvers; let i = index"
      >
        <div class="table-column crossover">
          <span class="table-column column-line">{{ crossOver.lineNumber }}</span>
          <span class="table-column">
            <i class="csx-arrows_switching"></i>
          </span>
          <span class="table-column highlighted"
            >{{ crossOver.location + ' ' + crossOver.fromTrack.name + ' -> ' + crossOver.toTrack.name }}
          </span>
        </div>
      </div>
    </div>

    <ng-container *ngIf="authority.comments && authority.comments.length > 0">
      <div *ngIf="isCommentsHaving(authority.comments, 'LINE11') || isCommentsHaving(authority.comments, 'PRIVATE')" class="commentsCntr">
        <ng-container *ngFor="let comment of getCommentType(authority.comments, 'LINE11'); let i = index">
          <div *ngIf="i === 0">Line 11</div>
          <div class="LINE11_TEXT">{{ comment.text }}</div>
        </ng-container>
        <div style="padding: 2px;"></div>
        <ng-container *ngFor="let comment of getCommentList(); let i = index">
          <div class="PRIVATE_TEXT">{{ comment.text }}</div>
        </ng-container>
      </div>
    </ng-container>
  </div>
</div>
  <p-footer class="p-dialog-footer">
    <div class="request-authority-content-wrapper request-authority-content-wrapper-footer">
      <div class="reportBySection">
        <div class="request-authority-content-row reportby-header">
          <strong>Report By:</strong>
          <span *ngIf="!getReportByLock() && !isLineItemModified() && !isUntilTimeChanged()"> {{ Direction[directionCancel] }} of...</span>
          <div *ngIf="getReportByLock()" class="reportByLock">
            <span class="csx-common_lock"> </span>Can't submit "Report By" unless all lines are in the same direction.
          </div>
          <div *ngIf="(isLineItemModified() || isUntilTimeChanged()) && !getReportByLock()" class="reportByLock">
            <span class="csx-common_lock"> </span>Cannot submit "Report By" while cancelling a line item, changing direction or modifying
            Until time.
          </div>
        </div>
        <div *ngIf="!getReportByLock() && !isLineItemModified() && !isUntilTimeChanged()" class="request-authority-content-row">
          <div class="request-authority-content-column reportby-location">
            <label> Location </label>
            <p-autoComplete
              [(ngModel)]="selectedLocation"
              [suggestions]="filteredOperatingFromList"
              (completeMethod)="search($event)"
              
              [dropdown]="true"
              field="commonName"
              styleClass="autocomplete"
              (onSelect)="operatingFromSelected()"
              (onBlur)="operatingFromSelected()"
              [ngClass]="{ invalid: errorMessageSelectedLocation !== null }"
            ></p-autoComplete>
            <div [hidden]="errorMessageSelectedLocation === null">
              <p class="error-text">{{ errorMessageSelectedLocation }}</p>
            </div>
          </div>
          <div class="request-authority-content-column reportby-direction">
            <label> Track </label>
            <!-- [appendTo]="maindialog" -->
            <p-dropdown
              [options]="trackListOperatingFrom"
              class="track"
              [(ngModel)]="selectedTrack"
              placeholder="Select Track"
              [ngClass]="{ 'invalid-track': errorMessageSelectedTrackFrom !== null }"
              field="label"
            ></p-dropdown>
            <div [hidden]="errorMessageSelectedTrackFrom === null">
              <p class="error-text">{{ errorMessageSelectedTrackFrom }}</p>
            </div>
          </div>
        </div>
      </div>
      <div
        *ngIf="authority.isAuthorityShared"
        class="reportBySection authority-shared"
        [ngClass]="authority.isAuthorityShared ? 'border-top' : ''"
      >
        <div class="request-authority-content-row reportby-header">
          <p>Since it is a Shared Authority, notify proposed modification with other shared users.</p>
        </div>
      </div>
      <div
        class="request-authority-content-row footer-row last-row content-action-group"
        [ngClass]="authority.isAuthorityShared ? 'shared-authority-buttons' : 'border-top'"
      >
        <button type="button" pButton label="Undo Changes" (click)="resetModify()" class="p-button-outlined undo-button"></button>
        <button
          type="button"
          pButton
          (click)="authority.isAuthorityShared ? showCloseModal() : closeModify()"
          label="Cancel"
          class="p-button-outlined"
        ></button>
        <button
          type="button"
          pButton
          label="{{ authority.isAuthorityShared ? 'Share Proposed Modification' : 'Submit' }}"
          [disabled]="
            (this.UserClickedReportBy === false && !this.isLineItemModified() && !this.isUntilTimeChanged()) ||
            (this.isUntilTimeChanged() && this.invalidUntilTime())
          "
          (click)="onSubmitOpenConfirmations()"
        ></button>
      </div>
    </div>
  </p-footer>
</p-dialog>
<changerequest-affirmations
  [authority]="authorityForAffirmation"
  [changeRequest]="changeRequestForAffirmation"
  (onCloseDialog)="closeDialog($event)"
  (onSubmit)="submitFromAffirmation()"
  [confirmation]="openConfirmation"
  [lineItems]="lineItemsModify"
>
</changerequest-affirmations>
